import { Stack, StackProps, styled } from '@mui/material';

import CourseUserCell from '../../../../../../../../../components/CourseUserCell';

export const UserReactions = styled((props: StackProps) => <Stack direction="column" gap={2} {...props} />)(
  ({ theme }) => ({
    margin: 0,
    paddingLeft: theme.spacing(2),
    listStyleType: 'none',
  })
) as typeof Stack;

export const StyledCourseUserCell = styled(CourseUserCell)(({ theme }) => ({
  padding: 0,
}));
